// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#phone-container .popup {
  max-width: 400px;
  text-align: left;
}

#phone-container .popup-title {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

#phone-container input[name="otp"] {
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/phone/Phone.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":["#phone-container .popup {\n  max-width: 400px;\n  text-align: left;\n}\n\n#phone-container .popup-title {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n#phone-container input[name=\"otp\"] {\n  font-size: 1.5rem;\n  font-weight: bold;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
